import { render, staticRenderFns } from "./ModalEditProject.vue?vue&type=template&id=27c25db8&"
import script from "./ModalEditProject.vue?vue&type=script&lang=js&"
export * from "./ModalEditProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports